import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, LazyLoadEvent } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ProformaService } from '../proforma.service';
import {AlertService, ConstantService} from '@app/_services';
import { first } from "rxjs";
import { PropertyLeadProfileService } from '@app/_components/property-lead-profile/property-lead-profile.service';

@Component({
    selector: 'app-proforma-copy-from-form',
    templateUrl: './proforma-copy-from-form.component.html',
    styleUrls: ['./proforma-copy-from-form.component.css'],
    standalone: false
})
export class ProformaCopyFromFormComponent implements OnInit {
  	form1: UntypedFormGroup;
	formLoading = false;
	formErrorMessage;
	proforma;
	ownerLeadProfileId:any;

	//Proforma
	proformaList: any[]=[];
	copyingProforma: any;
	proformaNotSelected: boolean = false;
	propertyLeadProfileList: any[] = [];
	copyingPropertyLeadProfile: any;
	profileNotSelected: boolean = false;

  validationMessages =
		{
			name: [{ type: 'required', message: 'New name is required.' }],
		};


  constructor(private formBuilder: UntypedFormBuilder,
		private messageService: MessageService,
		public proformaService : ProformaService,
		public propertyLeadProfileService : PropertyLeadProfileService,
		public dynamicDialogRef: DynamicDialogRef,
		private alertService: AlertService,
		public dynamicDialogConfig: DynamicDialogConfig) { 
			
		}

	@Output() doCopy = new EventEmitter<any>();

  ngOnInit(): void {
	if (this.dynamicDialogConfig.data) {
		// get the proforma
		this.proforma = this.dynamicDialogConfig.data.proforma;
		this.ownerLeadProfileId = this.dynamicDialogConfig.data.ownerLeadProfileId;
	}
	this.buildForm();
	let event : LazyLoadEvent = {};
    this.loadProformaList(event);

	// load property lead profiles for second dropdown
	if (this.ownerLeadProfileId) {
		this.loadPropertyLeadProfiles(this.ownerLeadProfileId);
	}

  }
  onFormSubmit() {
		if (this.form1.invalid) {
			return;
		}
		let copiedProformaName = this.copyingProforma.name;
		let proforma:any = {
			proformaId : this.proforma.proformaId,
			copyFromProformaId : this.copyingProforma.proformaId,
			propertyLeadProfileId : this.proforma.propertyLeadProfileId,
			isRequestedProforma: false
		};
		try {
			this.formLoading = true;
			this.proformaService.copyFromExistingProforma(proforma)
				.subscribe(
					res => {
						console.log('Response Of Copy Proforma: ' + JSON.stringify(res));
						this.messageService.add({
							severity: "success",
							summary: "Success",
							detail: copiedProformaName + ' Copied',
						});
						setTimeout( ()=>{
							this.formLoading = false;
							this.dynamicDialogRef.close(res.data.proforma);
						}, 2000)
					},
					err => {
						this.formLoading = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					},
					() => { });
		} catch (error) {
			this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
		}
	}

	onCopyForOwnerLead() {

		if (!this.copyingProforma || !this.copyingProforma.proformaId) {
			console.error("No proforma selected!");
			return;
		}
		if (!this.copyingPropertyLeadProfile || !this.copyingPropertyLeadProfile.propertyLeadProfileId) {
        	console.error("No property lead profile selected!");
			this.profileNotSelected = true;
			return;
		}
		let proforma: any = {
			copyFromProformaId: this.copyingProforma.proformaId,
			ownerLeadProfileId: this.ownerLeadProfileId,
			propertyLeadProfileId: this.copyingPropertyLeadProfile.propertyLeadProfileId,
			isRequestedProforma: false
		};
		try {
			this.formLoading = true;
			this.proformaService.generateOwnerLeadProforma(proforma)
				.subscribe(
					res => {
						console.log('Response Of Copy Proforma: ' + JSON.stringify(res));
						this.messageService.add({
							severity: "success",
							summary: "Success",
							detail: this.copyingProforma.name + ' Copied',
						});
						setTimeout( ()=>{
							this.formLoading = false;
							this.dynamicDialogRef.close(res.data.proforma);
						}, 2000)
					},
					err => {
						this.formLoading = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					},
					() => { });
		} catch (error) {
			this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
		}
	}

	buildForm() {
		this.form1 = this.formBuilder.group({
			proformaId: ['', Validators.required],
			propertyLeadProfileId: []
		});
	}

	// Fetch property lead profiles by owner lead profile ID
	loadPropertyLeadProfiles(ownerLeadProfileId: number) {
		this.formLoading = true;
		this.propertyLeadProfileService.findByOwner(ownerLeadProfileId)
			.pipe(first())
			.subscribe(
			(res: any) => {
				if (res.data?.propertyLeadProfiles) {
					this.propertyLeadProfileList = res.data.propertyLeadProfiles.map(profile => {
						profile.customOption = [
							profile.subjAdrStreet || '',
							profile.subjAdrUnit ? `#${profile.subjAdrUnit}` : '',
							profile.subjAdrCity ? `${profile.subjAdrCity},` : '',
							profile.subjAdrState || ''
						]
						.filter(part => part && part.trim().length > 0) // remove empty/null parts
						.join(' ');

						return profile;
					});
					// Auto-select if there is only ONE property lead
					if (this.propertyLeadProfileList.length === 1) {
						const singleProfile = this.propertyLeadProfileList[0];
							this.form1.patchValue({
							propertyLeadProfileId: singleProfile.propertyLeadProfileId
						});
						this.copyingPropertyLeadProfile = singleProfile;
					}
				}
			},
			(err: any) => {
				console.error('property lead profiles fetch error!: ' + JSON.stringify(err));
				this.alertService.error(err);
			},
			() => { this.formLoading = false; }
			);
	}

	onSelectPropertyLeadProfile(event: any) {
		if (this.propertyLeadProfileList.length > 0) {
			this.copyingPropertyLeadProfile = this.propertyLeadProfileList.find(p => p.propertyLeadProfileId === event.value);
		}
	}

	//Fetch proforma to show in proforma list to be copied
    loadProformaList(event: LazyLoadEvent) {
		this.formLoading = true;
		event.first = 0;
		event.rows = 1000;
		event.sortOrder = 1;
		event.multiSortMeta = [{field:"createDate",order: -1}];
		event.globalFilter = null;
		// Fetch proforma status is Draft, Published, Internal Only or Template and Visibility is Public
		// event.filters = {"status":{"value":[0,1,2,3],"matchMode":"in"}, "visibility":{"value":[0],"matchMode":"in"}}
		// 09-11-2025 Divy - As per Sarah, Fetch proforma status is Template
		event.filters = {"status":{"value":[3],"matchMode":"in"}}
		if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
		  event.multiSortMeta = [];
		  event.multiSortMeta.push({ field: 'createDate', order: -1 });
		}
		const pageNumber = Math.round(event.first / event.rows);
		this.proformaService.findByFilter(
		  pageNumber, event.rows,
		  event.sortField,
		  event.sortOrder,
		  event.multiSortMeta,
		  event.globalFilter,
		  event.filters).pipe(first()).subscribe(
			(res: any) => {
			  if(res.data.proformas != undefined) {
				res.data.proformas.forEach(proforma => {
				  var nameOption = proforma.name + ' - ';
				  var subjAdrStreet = proforma.propertyLeadProfile?.subjAdrStreet != undefined ? (proforma.propertyLeadProfile?.subjAdrStreet) : '';
				  var subjAdrUnit = proforma.propertyLeadProfile?.subjAdrUnit != undefined ? ('#'+proforma.propertyLeadProfile?.subjAdrUnit) : '';
				  var subjAdrCity = proforma.propertyLeadProfile?.subjAdrCity != undefined ? (proforma.propertyLeadProfile?.subjAdrCity + ',') : '';
				  var subjAdrState = proforma.propertyLeadProfile?.subjAdrState != undefined ? (proforma.propertyLeadProfile?.subjAdrState) : '';
				  var stableYrGrossTtl = proforma.stableYrGrossTtl != undefined ? ('$' + proforma.stableYrGrossTtl) : '';
				  var realtorFirstName = proforma.realtorProfile?.firstName != undefined ? (proforma.realtorProfile?.firstName + ' ') : '';
				  var realtorLastName = proforma.realtorProfile?.lastName != undefined ? (proforma.realtorProfile?.lastName) : '';
				  var realtorName = realtorFirstName + realtorLastName;
				  var ownerFirstName = proforma.ownerLeadProfile?.firstName != undefined ? (proforma.ownerLeadProfile?.firstName + ' ') : '';
				  var ownerLastName = proforma.ownerLeadProfile?.lastName != undefined ? (proforma.ownerLeadProfile?.lastName) : '';
				  var ownerName = ownerFirstName + ownerLastName;
				  var preparedDate = proforma.preparedDate != undefined ? (proforma.preparedDate) : '';
				  var visibility = proforma.visibility != undefined ? (this.proformaService.getVisibilityName(proforma)) : '';
				  //Show proforma option in dropdown with custom string
				  proforma.customOption = nameOption + ' ' + subjAdrStreet + ' ' + subjAdrUnit + ' ' + 
							subjAdrCity + ' ' + subjAdrState + ' ' + stableYrGrossTtl + ' ' + ownerName + ' ' + 
							realtorName + ' ' + preparedDate + ' ' + visibility
				});
			  }
			  this.proformaList = res.data.proformas;
			},
			(err: any) => {
			  console.error('reviews list error!: ' + JSON.stringify(err));
			  this.alertService.error(err);
			},
			() => { this.formLoading = false; }
		  );
	  }
  
	  onSelectProforma(event: any){
		if (this.proformaList.length > 0) {
		  this.proformaList.forEach(proforma => {
			if (proforma.proformaId == event.value) {
			  this.copyingProforma = proforma;
			}
		  });
		}
	  }

}
